/**
 * App.js — Point d'entrée minimal de la SPA.
 *
 * Toutes les routes sont déplacées dans `src/routes/` (par domaine) :
 *  - studentRoutes.jsx  (public, élèves, magazine, piliers, légal)
 *  - teacherRoutes.jsx  (Espace Pro, Cours, Eval, CCS, Réseau)
 *  - adminRoutes.jsx    (Dashboard admin sous /admin/*)
 *  - b2bRoutes.jsx      (Prestations freelance, conditionnées au flag)
 *
 * Le helpers `withLayout`, `withStudentLayout`, `TeacherGated` ont été
 * déplacés dans `src/lib/routeHelpers.jsx`.
 */
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AppProvider } from './contexts/AppContext';
import { NewFormatWelcomeModal } from './components/NewFormatWelcomeModal';
import { WhatsNewAugust2026Modal } from './components/WhatsNewAugust2026Modal';
import { AppRoutes } from './routes/AppRoutes';
import InstallPWABanner from './components/InstallPWABanner';
import ShareCourseButton from './components/ShareCourseButton';
import { useGlobalScrollReveal } from './hooks/useGlobalScrollReveal';
import { useSpotlightTracking } from './hooks/useSpotlightTracking';

function App() {
  useGlobalScrollReveal();
  useSpotlightTracking();
  return (
    <AppProvider>
      <BrowserRouter>
        {/* NewFormatBanner retiré (juin 2026) : doublonnait avec NewConceptBanner.
            Le pivot est annoncé désormais via NewConceptBanner sur la Home. */}
        <NewFormatWelcomeModal />
        <WhatsNewAugust2026Modal />
        <Toaster position="top-right" richColors />
        <AppRoutes />
        <ShareCourseButton />
        <InstallPWABanner />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
